import React from 'react';
import styled from 'styled-components';
import {
  SecondaryColor, maxMobile, maxWidth, primaryFont, retina, smMobile400, wMedium,
} from 'Utils/utilsStyle';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import { selectRefreshCompanyIds } from 'Selector/CompaniesSelector';
import { useSearchParams } from 'react-router-dom';
import RefreshIcon from '../assets/svgIcons/RefreshIcon';
import { selectClusterRefreshCompanyIds } from '../../../Selector/ClustersSelector';

const Wrapper = styled.div`
  &.iconModeClass {
    padding: 8px;
  }
  background-color: ${SecondaryColor};
  border: 1px solid ${SecondaryColor};
  border-radius: 8px;
  padding: 5px 10px;
  @media all and (max-width: ${maxWidth}), ${retina} {
    padding: 3px 13px 2px 13px;
  }
  @media all and (max-width: ${maxMobile}) {
    padding: 3px 10px 2px 10px;
  }
  @media all and (max-width: ${smMobile400}) {
    padding: 3px 8px 2px 8px;
    border-radius: 4px;
  }
  align-items: center;
  cursor: pointer;
  .refresh-icon {
    width: 18px;
    min-width: 18px;
    height: 17px;
    @media all and (max-width: ${maxWidth}), ${retina} {
      width: 14px;
      min-width: 14px;
      height: 14px;
    }
  }
  .button-text {
    font-family: ${primaryFont};
    font-weight: ${wMedium};
    font-size: 16px;
    line-height: 22px;
    margin-left: 10px;
    color: #fff;
    @media all and (max-width: ${maxWidth}), ${retina} {
      font-size: 13px;
      margin-left: 5px;
    }
    @media all and (max-width: ${smMobile400}) {
      display: none;
    }
  }
`;
type Props = {
  onRefresh: () => void,
  buttonText: string,
  iconMode?: boolean,
  isCluster?: boolean;
  clusterCompanyId?: number;
} & typeof defaultProps;

const defaultProps = {
  iconMode: false,
  isCluster: false,
  clusterCompanyId: 0,
};

const CustomRefreshButton = function CustomRefreshButton(props: Props) {
  const { onRefresh, buttonText, iconMode, isCluster, clusterCompanyId } = props;

  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const refreshCompanyIds = isCluster ? useSelector(selectClusterRefreshCompanyIds) : useSelector(selectRefreshCompanyIds);
  const isDisable = isCluster ? refreshCompanyIds.includes(clusterCompanyId ?? 0) : refreshCompanyIds.includes(companyIdParsed);
  return (
    <Wrapper
      className={classNames('custom-refresh-button', { iconModeClass: iconMode }, { disable: isDisable })}
      role="button"
      onClick={onRefresh}
    >
      <RefreshIcon fillColor="#fff" />
      {!iconMode ? (
        <span className="button-text">{buttonText}</span>
      ) : null}
    </Wrapper>
  );
};
CustomRefreshButton.defaultProps = defaultProps;
export default CustomRefreshButton;
